type TipCalloutProps = {
  iconClass?: string;
  title: string;
  description: string;
};

export default function TipCallout({
  iconClass = "ri-lightbulb-line",
  title,
  description,
}: TipCalloutProps) {
  return (
    <div className="bg-indigo-50 rounded-xl p-4 flex items-start gap-3">
      <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
        <i className={`${iconClass} text-indigo-500`} />
      </div>
      <div>
        <p className="text-sm font-medium text-indigo-700 mb-1">{title}</p>
        <p className="text-xs text-indigo-600/70 leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}
